import { CAMPAIGN_DATA_FETCH_ERR, CAMPAIGN_DATA_FETCH_SUCCESS } from './actions';

const initialState = {
  campaigns: [],
  error: null,
};

const campaignReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case CAMPAIGN_DATA_FETCH_SUCCESS:
      return {
        ...state,
        campaigns: data,
        error: null,
      };
    case CAMPAIGN_DATA_FETCH_ERR:
      return {
        ...state,
        error: err,
      };
    default:
      return state;
  }
};

export { campaignReducer };

